import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Martín',
  city: 'Mendoza'
}, {
  name: 'Carolina',
  city: 'La Plata'
}, {
  name: 'Diego',
  city: 'Tucumán'
}, {
  name: 'Valeria',
  city: 'Mar del Plata'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState('hace 2 minutos');
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentBuyer(randomBuyer);
      setTimeAgo(`hace ${randomTime} minuto${randomTime > 1 ? 's' : ''}`);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Subsequent popups every 15-30 seconds
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 15000) + 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-153">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-sm flex items-start space-x-4" data-id="element-154">
        <div className="flex-shrink-0 mt-1" data-id="element-155">
          <CheckCircle className="h-6 w-6 text-green-500" data-id="element-156" />
        </div>
        <div data-id="element-157">
          <p className="text-sm font-medium text-gray-900" data-id="element-158">
            <span className="font-bold" data-id="element-159">{currentBuyer.name}</span> de{' '}
            {currentBuyer.city}
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-160">
            acaba de comprar el Kit de Aprendizaje en Casa
          </p>
          <p className="text-xs text-gray-400 mt-2" data-id="element-161">
            {timeAgo} • Compra verificada
          </p>
        </div>
      </div>
    </div>;
}